import { useEffect, useLayoutEffect, useRef } from 'react';
import { bridge } from 'shared/src/utils';
import type { LoggingChannel } from 'shared/src/utils/bridge';
import type { ScreensReadModel } from 'shared/src/api';

export const useLogViewScreen = (
  data: ScreensReadModel | undefined,
  focused: boolean,
) => {
  const hasSentRef = useRef(false);

  useLayoutEffect(() => {
    if (!focused || !data || hasSentRef.current) return;

    hasSentRef.current = true;
    bridge.logAnalyticsEvent({
      name: `VIEW_${data.screenName}`,
      ...(data.viewEventChannels.length > 0 && {
        channel: data.viewEventChannels as LoggingChannel[],
      }),
      analytics: {
        ...data.logging.analytics,
        SCREEN: data.screenName,
      },
      ably_only_log: data.viewEventLogging.ably_only_log,
    });
  }, [focused, data]);

  // 탭 재진입 시 다시 보낼 수 있도록 unfocus 시 리셋
  useEffect(() => {
    if (!focused) {
      hasSentRef.current = false;
    }
  }, [focused]);
};
